import React from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { IAppPropsWithRoute } from '../../../common/types';

import {
    Box, Grid,
    Button, IconButton,
    TextField, Select, MenuItem,
    FormHelperText, FormControl, FormControlLabel,
    RadioGroup, Radio, Checkbox,
    InputAdornment
} from '@material-ui/core';
import { useStyles } from "../styles";
import * as Icons from "../iconComponents";
import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import { useState } from 'react';
import IndexedDb from '../IndexedDb';
import { KeyboardDatePicker, KeyboardTimePicker, MuiPickersUtilsProvider, TimePicker, TimePickerView } from '@material-ui/pickers';
import { format, getDate } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { time } from 'console';
import TimeInput from '../../ui/TimeInput';




interface PcrWidgetProps extends IAppPropsWithRoute {

};

const SubFormWidget: React.FC<PcrWidgetProps> = () => {
    const classes = useStyles();
    const history = useHistory();
    const[Indexdb,setIndexdb]=useState("");
    
    const[progresstime,setprogresstime]=useState(new Date());
    const[progressnote,setprogressnote]=useState("");
    
    
    const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError } = useFormContext();
    const pcrType = watch("pcr_type");
    const [formFields, setFormFields] = useState([
        {time: '', progressnote: '' },
      ])
    const {
        fields: ProgressFields,
        append: ProgressAppend,
        remove: ProgressRemove
    } = useFieldArray({ control, name: "progressnotes" });
    
    React.useEffect(() => {
        let db: any = null;
        db = localStorage.getItem("PatientDB");
        setIndexdb(db);
        getindexdbvalues();
    }, [])

      
      const handleFormChangeProgressnotetime = (event:any, index:any) => {
        let data = [...formFields];
        setFormFields(data);
        setprogresstime(event.target.value); 
      }
      const handleFormChangeProgressnotenote = (event:any, index:any) => {
        let data = [...formFields];
        setFormFields(data);
        setprogressnote(event.target.value); 
      }

    const submit = async(index:any): Promise<void> => {
        let values = getValues();       
        if(Indexdb!=null || Indexdb !="")
        {
            const indexedDb = new IndexedDb(Indexdb);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord); 
            var res = await indexedDb.getValue('ProgressNotes','ProgressNotes'+index);             
            let mtime="";
            let mtimeval="";
            let mnote="";
            if(res !== undefined)
            {
                mtime=res.value.time;
                mtimeval=res.value.time !=undefined ? format(res.value.time,"HH:mm:ss"):"";
                mnote=res.value.progressnote;
            }
            await indexedDb.putBulkValue('ProgressNotes',
             [{ time: progresstime !==null ? progresstime:mtime,
                formatedtime:progresstime !==null ? format(progresstime,"HH:mm:ss"):mtimeval,
                progressnote: progressnote !==null?progressnote:mnote}],'ProgressNotes'+index);
        }   
      }

    const getindexdbvalues = async (): Promise<void> => {
        let db:any = null;
        let observationdata = null ;
        db = localStorage.getItem("PatientDB");
        if(db!=null && db !="")
        {
        const indexedDb = new IndexedDb(db);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);
        let val = await indexedDb.getAllValue('ProgressNotes');
        ProgressRemove();
        for(let i=0;i<val.length;i++)
        {
            if(val[i].Key.includes("ProgressNotes"))
            {
                let res = val[i].value;
                // ProgressFields.push(res);
                ProgressAppend(res)
                //console.log(ProgressFields);
            }
        }
        }       
    }

    const [selectedDate, setSelectedDate] = useState(new Date());

    const handleDateChange = (name :any,date:any,index:any) => {
        setprogresstime(new Date(date));
        ProgressFields.forEach((item: any,fieldindex:any) => {
            if (fieldindex === index) {
                item.time = date;
            }})
      };



      const handleindexdbsave = async (Key:any,value:any): Promise<void> => {       
        let values = getValues(); 
                
        if(Indexdb!=null || Indexdb !="")
        {
            const indexedDb = new IndexedDb(Indexdb);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            await indexedDb.deleteValue('progressnotes', Key);
            await indexedDb.putValue('progressnotes', { column:value,Patid:0 },Key);
        }    
    }
   

    const handleindexdbdelete = async (Key:any): Promise<void> => {     
        if(Indexdb!=null || Indexdb !="")
        {
        const indexedDb = new IndexedDb(Indexdb);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);      
        await indexedDb.deleteValue('ProgressNotes', Key);  
        }     
    }
    const handleAddRow = async () => {
        const lastIndex = await ProgressFields.length;
        await ProgressAppend({ time: new Date(), progressnote: "" });
        if(lastIndex >= 0)
        {
            const lastInput = document.getElementById(`progressFocus${lastIndex}`) as HTMLElement;
            if(lastInput)
            {
                lastInput.focus();
            }
        }
    }
    
    return (
        <div className={classes.notesFormList}>
            <div className={"headingSection"}>
                <div className={classes.pcrAddTabHeading}>
                    Progress Notes
                </div>
            </div>
            
            {ProgressFields.map((item, index) => (
            <Grid container className={"FormListItem"} spacing={0} key={item.id}>
                <Grid item xs={11} sm={11}>
                    <Grid container spacing={5}>
                        <Grid item xs={12} sm={3}>
                            <div className={classes.formControlLabel}>
                                TIME
                            </div>
                            <Controller
                                control={control}
                                name={`progress_notes[${index}].time`}  
                                // defaultValue={new Date(`${item.time}`)}                            
                                render={({ onChange, onBlur, value, name }) => (
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <TimeInput
                                            inputVariant="outlined"
                                            //label="Material Date Picker"   
                                            id={"time"+index}                            
                                            value={item?.time || null}     
                                            // defaultValue={new Date().getHours()+":"+new Date().getMinutes()+":"+new Date().getSeconds()}                          
                                            format="HH:mm:ss"
                                            cancelLabel={false}
                                            okLabel={false}
                                            autoOk={true}
                                            // onChange={(date, value) => {props.onChange(date); handleDateChange(date,index); }}                              
                                            // onBlur={() =>{
                                            //     submit(index);
                                            // }}
                                            // onChange={(date, value) => {
                                            //     onChange(date); handleDateChange(date,index);}}                              
                                            //     onBlur={() =>{
                                            //     submit(index);                                                                                                        
                                            // }}

                                            onChange={
                                                (date, value) => 
                                                {
                                                    onChange(date); 
                                                    handleDateChange(item.name,date,index);
                                                }
                                            }
                                            //inputProps={{ classes: { root: classes.textFieldInput } }}
                                            // onFocusCapture={(e) =>
                                            //    submit(index)
                                            //     }
                                            InputProps={{ classes: { root: classes.textFieldInput } }}
                                            inputProps={{ readOnly: true }}
                                            error={errors.progress_notes?.[index]?.time}
                                            helperText={errors.progress_notes?.[index]?.time ? errors.progress_notes?.[index]?.time.message : ""}
                                            keyboardIcon={<Icons.TimePickerIcon />}
                                        />
                                    </MuiPickersUtilsProvider>
                                )}
                                rules={{
                                    //required: "Progress Time is required",
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={9}>
                            <div className={classes.formControlLabel}>
                                NOTE
                            </div>
                            <Controller
                                control={control}
                                name={`progress_notes[${index}].note`}
                                defaultValue={`${item.progressnote !=="undefined" ? item.progressnote:""}`}
                                render={props => (
                                    <TextField
                                        variant='outlined'
                                        id={`progressFocus${index}`}
                                        defaultValue={`${item.progressnote}`} // make sure to set up defaultValue 
                                        InputProps={{ classes: { root: classes.multilinetextFieldInput } }}
                                        inputProps={{ maxLength: 500, minLength: 0,autocomplete:'disabled' }}
                                        error={errors.progress_notes?.[index]?.note}
                                        helperText={errors.progress_notes?.[index]?.note ? errors.progress_notes?.[index]?.note.message : ""}
                                        onChange={event => handleFormChangeProgressnotenote(event, index)}
                                        onBlur={(e) => submit(index)}
                                        placeholder=""
                                        multiline
                                        rows={3}
                                    />
                                )}
                                // rules={{
                                //     required: "Progress Note is required",
                                // }}
                            
                                // control={control}
                                // name={`progress_notes[${index}].note`}
                                // defaultValue=""
                                // as={
                                //     <TextField
                                //         variant='outlined'
                                //         InputProps={{ classes: { root: classes.textFieldInput } }}
                                //         error={errors.progress_notes?.[index]?.note}
                                //         helperText={errors.progress_notes?.[index]?.note ? errors.progress_notes?.[index]?.note.message : ""}
                                //         placeholder=""
                                //     />
                                // }
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={1} sm={1}>
                    <div className={"removeBtn"} 
                        onClick={event => {
                            ProgressRemove(index)
                            handleindexdbdelete('ProgressNotes'+index);                                                                          
                          }}
                        >
                        <Icons.CloseIcon />
                    </div>
                </Grid>
            </Grid>
            ))}
            
            <div className={"addButton"}>
                <Button className={classes.yellowBtn} onClick={handleAddRow}>
                    Add Note
                </Button>
            </div>
        </div>
    );
}

export default React.memo(withRouter(SubFormWidget));


           

